/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { firebase } from "@/utilities/firebase";
import router from "@/router.js";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////
  // TODO { commit, dispatch } - removed dispatch, can add back in if needed
  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },

  logoutUser({ commit }) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        router.push({ name: "login" });
      })
      .catch(error => {
        commit("LOG_OUT_USER");
        router.push({ name: "login" });
        console.error(error);
      });
  },
  //manage settings
  updateSettingList({ commit }, payload) {
    commit("UPDATE_SETTING_LIST", payload);
  },
  //manage user list
  updateUserList({ commit }, payload) {
    commit("UPDATE_USER_LIST", payload);
  },
  //manage user list
  updateGlobalData({ commit }, payload) {
    commit("UPDATE_GLOBAL_DATA", payload);
  },
  //manage user list
  updateVictorianData({ commit }, payload) {
    commit("UPDATE_VICTORIAN_DATA", payload);
  },
  //manage user list
  updateHospitalData({ commit }, payload) {
    commit("UPDATE_HOSPITAL_DATA", payload);
  },
  updateActiveHospital({ commit }, payload) {
    commit("UPDATE_ACTIVE_HOSPITAL", payload);
  },
  updateChartHeight({ commit }, payload) {
    commit("UPDATE_CHART_HEIGHT", payload);
  }
};

export default actions;
